import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { login, getEmInfo, getProjectList } from '@/api';
import { getToken, setToken, removeToken, setExpiresIn } from '@/utils/auth';
import { clearSessionStorage } from '@/utils/utils';
import { resetRouter } from '@/router';
import store from '@/store';

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule   {
  token = getToken() || ''; // token
  expiresIn = 0; // 超时时间
  mobile = ''; // 电话
  fullName = ''; // 雇员姓名
  employeeId = -1; // 雇员id
  projectId = -1; // 项目id
  projectName = ''; // 项目名称
  customerId = -1; // 客户id
  customerName = ''; // 客户名称
  projectList = []; // 项目列表
  employeeInfo= []; // 雇员对象列表
  


  @Mutation
  SET_TOKEN(token) {
    this.token = token;
  }

  @Mutation
  SET_EXPIRES_IN(time) {
    this.expiresIn = time;
  }

/**
 * 
 * @param {*} projectId 项目相关的东西 
 */

@Mutation
SET_PROJECTIDLIST(projectIdList) {
  this.projectList = projectIdList;
}
  @Mutation
  SET_PROJECTID(projectId) {
    this.projectId = projectId;
  }

  @Mutation
  SET_PROJECTNAME(projectName) {
    this.projectName = projectName;
  }

  @Mutation
  SET_CUSTOMERNAMERID(customerId) {
    this.customerId = customerId;
  }

  @Mutation
  SET_CUSTOMERNAME(customerName) {
    this.customerName = customerName;
  }

  /**
   * 
   * @param {*} fullName 雇员相关的东西 
   */

  @Mutation
  SET_EMPLOYEEINFO(employeeInfo) {
    this.employeeInfo = employeeInfo;
  }


  @Mutation
  SET_USERNAME(fullName) {
    this.fullName = fullName;
  }

  @Mutation
  SET_USERID(employeeId) {
    this.employeeId = employeeId;
  }

  @Mutation
  SET_MOBILE(mobile) {
    this.mobile = mobile;
  }

  @Action({rawError: true})
  async Login({ fullName, idcardNumber }) {
    const { data } = await login({ fullName, idcardNumber });
    setToken(data.access_token);
    this.SET_TOKEN(data.access_token);
    setExpiresIn(data.expires_in);
    this.SET_EXPIRES_IN(data.expires_in);
  }

  @Action({rawError: true})
  async getProjectList() {
    const { data } = await getProjectList();
    this.SET_PROJECTIDLIST(data);
  }

  @Action({ rawError: true })
  async getEmInfo(checkProjectId) {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!');
    }
    const { data } = await getEmInfo(checkProjectId);
    if (!data) {
      throw Error('Verification failed, please Login again.');
    } else {
      this.SET_EMPLOYEEINFO(data);
    }
    const { fullName, employeeId,  mobile,  customerName, customerId, projectId, projectName } = data;
    this.SET_USERNAME(fullName); // 雇员名称
    this.SET_MOBILE(mobile); // 雇员电话
    this.SET_USERID(employeeId); // 雇员id
    this.SET_PROJECTID(projectId); // 项目id
    this.SET_PROJECTNAME(projectName); // 项目名称
    this.SET_CUSTOMERNAME(customerName); // 客户名称
    this.SET_CUSTOMERNAMERID(customerId); // 客户id
  }

  @Action
  LogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!');
    }
    // await logout(); // 不需要退出登录
    removeToken();
    resetRouter();
    sessionStorage.clear();
    this.SET_TOKEN('');
    location.href = '/';
  }

  // 清除制定的会话存储
  @Action
  removeSessionStorage(SessionStorageObj) {
    for (let i = 0; i < SessionStorageObj.lengh; i++) {
      clearSessionStorage(`${Object.keys(SessionStorageObj[i]) || SessionStorageObj[i]}`); // 格式写为json对象
    }
  }

  // @Action
  // async RefreshToken() {
  //   const { data } = await refresh();
  //   setToken(data.access_token);
  //   this.SET_TOKEN(data.access_token);
  //   setExpiresIn(data.expires_in);
  //   this.SET_EXPIRES_IN(data.expires_in);
  // }

  @Action
  ResetToken() {
    removeToken();
    this.SET_TOKEN('');
    this.SET_ROLES([]);
    this.SET_PERMISSIONS([]);
  }
}

export const UserModule = getModule(User);
